cosnole.log('I get called from print.js!');